import { useEffect, useRef } from 'react';
import {
  getNotificationsConnection,
  startNotifications,
} from './notificationsConnection';

export function useNotifications({ token, onNotification }) {
  const onRef = useRef(onNotification);
  onRef.current = onNotification;

  useEffect(() => {
    if (!token) return;

    const getToken = () => token;
    const conn = getNotificationsConnection(getToken);

    const handler = (dto) => onRef.current?.(dto);

    // event name must match backend test
    conn.on('NotificationEventChange', handler); // :contentReference[oaicite:0]{index=0}

    startNotifications(getToken).catch((err) => {
      console.error('SignalR start failed:', err);
    });

    return () => {
      conn.off('NotificationEventChange', handler);
    };
  }, [token]);
}
